import { GlobalStyles } from '@mui/material';
import mulishFont from './fonts/Mulish.ttf';

export const FontProvider = () => (
  <GlobalStyles
    styles={{
      '@font-face': {
        fontFamily: 'Mulish',
        fontWeight: '400 900',
        fontDisplay: 'swap',
        src: `url(${mulishFont}) format('truetype')`
      }
    }}
  />
);

export default FontProvider;
